import { Link } from 'react-router-dom';
import crestaLogo from '../assets/cresta_logo_horizontal.png';

/**
 * Premium Footer Component
 * 
 * Modern, glassmorphism-inspired footer with organized layout
 * and premium visual aesthetics.
 */
function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="landing-footer">
            {/* Gradient Background Orbs */}
            <div className="footer-orb footer-orb-1"></div>
            <div className="footer-orb footer-orb-2"></div>

            <div className="footer-main">
                <div className="footer-content-wrapper">
                    {/* Top Section: Logo + CTA */}
                    <div className="footer-top">
                        <div className="footer-brand-section">
                            <img
                                src={crestaLogo}
                                alt="Cresta Logo"
                                className="footer-logo-premium"
                            />
                            <p className="footer-tagline">
                                La plataforma más completa para salones de belleza modernos.
                            </p>
                            <p className="footer-status">
                                <span className="status-dot" style={{ backgroundColor: '#ef4444' }}></span>
                                Proyecto en Pausa • Modo Mantenimiento
                            </p>
                        </div>

                        {/* Social Media Cards */}
                        <div className="footer-social-section">
                            <p className="social-heading">Síguenos</p>
                            <div className="social-cards">
                                <a
                                    href="https://www.instagram.com/cresta.app/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-card social-instagram"
                                    aria-label="Instagram"
                                >
                                    <svg fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
                                    </svg>
                                    <span>Instagram</span>
                                </a>
                                <a
                                    href="https://www.facebook.com/profile.php?id=61586726908365"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-card social-facebook"
                                    aria-label="Facebook"
                                >
                                    <svg fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                    <span>Facebook</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="footer-divider"></div>

                    {/* Links Grid */}
                    <div className="footer-links-grid">
                        <div className="footer-links-column">
                            <h4 className="footer-column-title">Producto</h4>
                            <ul className="footer-link-list">
                                <li><a href="#features">Características</a></li>
                                <li><a href="#screenshots">Galería</a></li>
                            </ul>
                        </div>

                        <div className="footer-links-column">
                            <h4 className="footer-column-title">Legal</h4>
                            <ul className="footer-link-list">
                                <li><Link to="/privacy">Política de Privacidad</Link></li>
                                <li><Link to="/terms">Términos y Condiciones</Link></li>
                            </ul>
                        </div>

                        <div className="footer-links-column">
                            <h4 className="footer-column-title">Contacto</h4>
                            <ul className="footer-link-list">
                                <li>
                                    <a href="mailto:info@cr3sta.com" className="footer-link-email">
                                        <svg viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                        </svg>
                                        info@cr3sta.com
                                    </a>
                                </li>
                                <li className="footer-location">
                                    <svg viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                    </svg>
                                    Cali, Colombia 🇨🇴
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom-bar">
                <div className="footer-bottom-container">
                    <p className="footer-copyright">
                        © {currentYear} Cresta · Todos los derechos reservados
                    </p>
                    <a
                        href="https://cottontoptech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-ctt-badge"
                    >
                        <span>Hecho con</span>
                        <span className="heart-icon">❤️</span>
                        <span>por</span>
                        <span className="ctt-name">CottonTopTech</span>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
